import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './site.routes';
import uuidv4  from 'uuid/v4';
import Promise from 'bluebird';

export class SiteController {
  users = [];
  newThing = '';

  /*@ngInject*/
  constructor($http, $scope, $location, $timeout, $filter, $stateParams, appConfig, Auth, toastr, Traduction) {
    var vm = this;
    vm.orderBy = "client";
    vm.reverseSort = false;
    vm.loading = true;
    $scope.Auth = Auth;

    /*$http.get(appConfig.baseUrl + '/public/template/dictionnaire.json').then(function(resp){
      vm.dictionnaireTemplate = resp.data;
      console.log(vm.dictionnaireTemplate);
      _(vm.dictionnaireTemplate).forEach((dic) => {
        console.log(dic);
      })
    })*/

    setTimeout(function(){
      $http.get(appConfig.baseUrl + '/public/template/dictionnaire.json').then(function(resp){
        vm.dictionnaireTemplate = resp.data;
        fetchPostes();
      })
      $http.get(`/api/sites/get/flags`).then(function(resp){
        vm.flags = resp.data;
        setTimeout(function() {
          $('.selectpicker').selectpicker('refresh');
        }, 10);
      })
    },10)

    vm.createPoste = function(form){ 
      $("#addPoste").modal('show');
      vm.data = {};
      vm.data.siteId = vm.site._id;
      vm.availableLanguages = vm.site.langues;
      setTimeout(function() {
        $('.selectpicker').selectpicker('refresh');
      }, 10);
    }

    vm.editPoste = function(poste) {
      $location.path(`/poste/${poste._id}`);
    }

    vm.openPoste = function(poste, $event) {
      Auth.logout();
      $location.path(`/borne_categories/${poste._id}`);
    }

    vm.addPoste = function(form){
      if(form.$valid) {
        vm.loading = true;
        vm.errors = undefined;
        $scope.clicked = true;
        if(!vm.data.siteId) {
          $scope.clicked = false;
          return vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : 'Vous devez selectionner un site.'};
        }
        $http.post(`/api/postes`, vm.data).then(response => {
          $("#addPoste").modal('hide');
          setTimeout(function(){
            vm.loading = false;
            $location.path(`/poste/${response.data._id}`);
            $scope.$apply();
          },1000)
        }).catch(err => {
          console.log(err);
          vm.loading = false;
          vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : err.data.message};
          $scope.clicked = false;
        });
      }
    }

    vm.copyPoste = function(poste) {
      vm.data = {};
      vm.posteToCopy = angular.copy(poste);
      $('#copyPoste').modal('show');
    }

    vm.validateCopyPoste = function() {
      vm.posteToCopy.name = vm.data.name;
      vm.posteToCopy._id = undefined;
      console.log(vm.posteToCopy);
      $http.post('/api/postes/copy', vm.posteToCopy).then(function(){
        $('#copyPoste').modal('hide');
        location.reload();
      })
    }

    vm.deletePoste = function(poste) {
      vm.posteToDelete = poste;
      $('#deletePoste').modal('show');
    }

    vm.validateDelete = function() {
      $scope.clicked = true;
      $http.delete(`/api/postes/${vm.posteToDelete._id}`).then(function(){
        fetchPostes();
        $('#deletePoste').modal('hide');
        $scope.clicked = false;
        vm.posteToDelete = {};
      });
    }

    vm.sharePoste = function(poste){ 
      $("#sharePoste").modal('show');
      vm.data = {};
      vm.data.poste = poste;
      vm.data.emails = [{},{},{}];
      vm.data.link = appConfig.baseUrl + '/borne_categories/' + poste._id;
    }

    vm.copyLink = function(){
      $('#link')[0].select();
      document.execCommand('copy');
    }

    vm.addEmail = function(){ 
      vm.data.emails.push({});
    }

    vm.removeEmail = function(email){ 
      vm.data.emails.splice(vm.data.emails.indexOf(email), 1);
    }

    vm.sendEmail = function(email){
      // console.log({emails: _.map(vm.data.emails, "address"), link : vm.data.link, poste : vm.data.poste});
      $http.post(`/api/postes/sharePoste`, {emails: _.map(vm.data.emails, "address"), link : vm.data.link, poste : vm.data.poste}).then(response => {
        $("#sharePoste").modal('hide');
      })
    }

    vm.createLangue = function(form){ 
      vm.data = {};
      vm.data.flag = vm.flags[0];
      $('.langueSelect').css("background-image", "url(public/img/flags/"+vm.data.flag.img+")");
      $("#addLangue").modal('show');
      setTimeout(function() {
        $('.selectpicker').selectpicker('refresh');
      }, 10);
    }

    vm.editLangue = function(langue, index) {
      vm.data = angular.copy(langue);
      vm.data.index = index;
      vm.data.flag = vm.flags[vm.flags.indexOf(_.find(vm.flags, ['name', vm.data.flag.name]))];
      $('#addLangue').modal('show');
      setTimeout(function() {
        $('.selectpicker').selectpicker('refresh');
      }, 10);
    }

    vm.addLangue = function(form){
      if(form.$valid) {
        vm.errors = undefined;
        $scope.clicked = true;
        if(!Array.isArray(vm.site.langues)) vm.site.langues = [];
        if(!vm.data.id) vm.data.id = uuidv4();
        if(vm.data.index != undefined) vm.site.langues[vm.data.index] = vm.data;
        else vm.site.langues.push(vm.data);
        if(!vm.data.dictionnary) vm.data.dictionnary = vm.dictionnaireTemplate;

        $http.patch(`/api/sites/${vm.site._id}?addLangue`, vm.site).then(response => {
          $http.get(`/api/sites/${vm.site._id}`).then(response => {
              vm.site = response.data;
              $('#addLangue').modal('hide');
              $scope.clicked = false;
              vm.data = {};
            });
        }).catch(err => {
          console.log(err);
          vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : err.data.message};
          $scope.clicked = false;
        });
      }
    }

    vm.deleteLangue = function(data) {
      vm.langueToDelete = data;
      $('#deleteLangue').modal('show')
    }

    vm.validateDeleteLangue = function() {
      $scope.clicked = true;
      console.log(vm.langueToDelete);
      var availablePostes = _.filter(vm.site.Postes, function(poste){
        if(poste.langues.includes(vm.langueToDelete.id)) return poste;
      })

      return Promise.all(_.map(availablePostes, function(poste){
        var availableCategories = _.filter(poste.Categories, function(categorie){
          if(categorie.langues.includes(vm.langueToDelete.id)) return categorie;
        })

        poste.langues = _.filter(poste.langues, function(langue){
          if(langue != vm.langueToDelete.id) return langue;
        })

        return Promise.all(_.map(availableCategories, function(categorie){
          categorie.langues = _.filter(categorie.langues, function(langue){
            if(langue != vm.langueToDelete.id) return langue;
          })
          categorie.traductions = _.filter(categorie.traductions, function(traduction){
            if(traduction.id != vm.langueToDelete.id) return traduction;
          })

          return Promise.all(_.map(categorie.Formations, function(formation){
            _.forEach(formation.supports, function(support){
              support.langues = _.filter(support.langues, function(langue){
                if(langue.langueId != vm.langueToDelete.id) return langue;
              })
            })
            _.forEach(formation.questions, function(question){
              question.langues = _.filter(question.langues, function(langue){
                if(langue.langueId != vm.langueToDelete.id) return langue;
              })
            })
            return $http.patch(`/api/formations/${formation._id}`, formation).then(function(){
              console.log('form a jour')
              return 'ok'
            })
          })).then(function(){
            return $http.patch(`/api/categories/${categorie._id}`, categorie).then(function(){
              console.log('cat a jour')
              return 'ok'
            })
          })
        })).then(function(){
          return $http.patch(`/api/postes/${poste._id}`, poste).then(function(){
            console.log('poste a jour')
            return 'ok'
          })
        })
      })).then(function(){
        vm.site.langues.splice(vm.site.langues.indexOf(vm.langueToDelete), 1);
        $http.patch(`/api/sites/${vm.site._id}`, vm.site).then(response => {
          console.log('site a jour');
          $http.get(`/api/sites/${vm.site._id}`).then(response => {
            vm.site = response.data;
            vm.data = {};
            $scope.clicked = false;
            $('#deleteLangue').modal('hide');
          });
        }).catch(err => {
          console.log(err);
          vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : err.data.message};
          $scope.clicked = false;
        });
      })
    }

    $scope.$watch('vm.data.flag',function(newFlag){
      if(vm.data && newFlag) {
        $('.langueSelect').css("background-image", "url(public/img/flags/"+newFlag.img+")");
      }
    })

    vm.saveLangue = function(form, langue){
      console.log(vm.site);
      $http.patch(`/api/sites/${vm.site._id}`, vm.site).then(function(response){
        vm.site = response.data;
        vm.data = vm.site.langues;
        toastr.success($filter('translate')('saved'), $filter('translate')('siteUpdated'));
      })
    }

    vm.save = function(form){
      $http.patch(`/api/sites/${vm.site._id}`, vm.site).then(function(response){
        vm.site = response.data;
        toastr.success($filter('translate')('saved'), $filter('translate')('siteUpdated'));
      })
    }

    vm.isObject = function(value){
      return typeof value === "object";
    }

    function fetchPostes(){
      return new Promise(function (resolve, reject) {
        Auth.getCurrentUser().then(function(){
          if(Auth.isAdminSync()) {
            $http.get('/api/sites/'+ $stateParams.id).then(response => {
              vm.site = response.data;
              vm.postes = vm.site.Postes;
              vm.loading = false;
              checkIfPostesAvailable(vm.postes);
              _.map(vm.site.langues, function(langue){
                _.map(vm.dictionnaireTemplate, function(childs, key){
                    if(!langue.dictionnary[key]) langue.dictionnary[key] = {};
                  _.forEach(childs, function(value, keyName){
                    if(!langue.dictionnary[key][keyName]) langue.dictionnary[key][keyName] = '';
                  })
                })
              })
              resolve(0);
            })
          } else {
            $http.get('/api/users/my/sites').then(response => {
              vm.site = _.find(response.data.Sites, ['_id', $stateParams.id]);
              //Fill with only needed postes
              if(Auth.isHigherRanked('user')) vm.postes = vm.site.Postes;
              else {
                vm.postes = [];
                _.forEach(response.data.Categories, function(cat){
                _(vm.site.Postes).forEach((poste) => {
                  if(_(poste.Categories).map('_id').value().includes(cat._id) && !_(vm.postes).map('_id').value().includes(poste._id)) vm.postes.push(poste)
                })
                })
              }
              vm.loading = false;
              checkIfPostesAvailable(vm.postes);
              _.map(vm.site.langues, function(langue){
                _.map(vm.dictionnaireTemplate, function(childs, key){
                    if(!langue.dictionnary[key]) {
                      langue.dictionnary[key] = {};
                    }
                  _.forEach(childs, function(value, keyName){
                    if(!langue.dictionnary[key][keyName]) langue.dictionnary[key][keyName] = '';
                  })
                })
              })
              resolve(0);
            })
          }
        })
      })
    }

    function checkIfPostesAvailable(postes){
      _.forEach(postes, function(poste){
        poste.available = true;
      })
    }
  }
}

export default angular.module('aperamApp.site', [uiRouter])
  .config(routing)
  .component('site', {
    template: require('./site.html'),
    controller: SiteController,
    controllerAs:'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/site/site.component.js